import { render, staticRenderFns } from "./LoginLoading.vue?vue&type=template&id=54bf3dcf&scoped=true"
import script from "./LoginLoading.vue?vue&type=script&lang=js"
export * from "./LoginLoading.vue?vue&type=script&lang=js"
import style0 from "./LoginLoading.vue?vue&type=style&index=0&id=54bf3dcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bf3dcf",
  null
  
)

export default component.exports